<template>
  <div>
    <div class="page-header">
      <h1 class="page-title">Acampantes</h1>
      <button class="btn-primary" @click="openNew">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
        <span>Novo</span>
      </button>
    </div>

    <div class="filters">
      <div class="chip-row">
        <button
          class="filter-chip"
          :class="{ active: equipeFilter === 'ALL' }"
          @click="equipeFilter = 'ALL'"
        >Todos <span class="chip-count">{{ store.totalCount }}</span></button>
        <button
          v-for="equipe in equipes"
          :key="equipe.value"
          class="filter-chip"
          :class="{ active: equipeFilter === equipe.value }"
          :style="equipeFilter === equipe.value
            ? { background: equipe.hex, color: equipe.textColor, borderColor: equipe.mainColor }
            : { borderColor: equipe.mainColor, color: equipe.mainColor }"
          @click="equipeFilter = equipe.value"
        >
          {{ equipe.label }}
          <span class="chip-count">{{ store.byEquipe(equipe.value).length }}</span>
        </button>
        <button
          v-if="semEquipeCount > 0"
          class="filter-chip filter-chip-sem-equipe"
          :class="{ active: equipeFilter === 'NONE' }"
          @click="equipeFilter = 'NONE'"
        >
          Sem equipe
          <span class="chip-count">{{ semEquipeCount }}</span>
        </button>
      </div>

      <div class="search-box">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" class="search-icon"><path fill="currentColor" d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0c.41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14z"/></svg>
        <input class="input search-input" type="text" v-model="searchQuery" placeholder="Buscar por nome..." />
        <button v-if="searchQuery" class="clear-btn" @click="searchQuery = ''" aria-label="Limpar busca">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"/></svg>
        </button>
      </div>
    </div>

    <SkeletonLoader v-if="store.loading && store.acampantes.length === 0" variant="table-row" :count="6" />

    <div class="acampante-list" v-else-if="filtered.length > 0">
      <button
        type="button"
        class="acampante-item card"
        v-for="item in filtered"
        :key="item.id"
        :aria-label="`Ver detalhes de ${item.name}`"
        @click="openDetails(item)"
      >
        <div class="item-main">
          <div class="item-name-row">
            <span class="item-name">{{ item.name }}</span>
            <EquipeChip :equipe="item.equipe" />
            <TransporteBadge v-if="item.check && item.transporte" :value="item.transporte" size="small" />
          </div>
          <div class="item-meta">
            <span v-if="item.contato" class="item-contato">{{ item.contato }}</span>
            <span class="item-status" :class="item.check ? 'status-confirmed' : 'status-pending'">
              <span v-if="item.check">✓ Confirmado</span>
              <span v-else>Aguardando</span>
            </span>
          </div>
        </div>

        <div class="item-actions" @click.stop>
          <button class="icon-btn" @click="openQr(item)" aria-label="Ver QR Code" title="Ver QR Code">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M3 11h8V3H3v8zm2-6h4v4H5V5zm-2 16h8v-8H3v8zm2-6h4v4H5v-4zm8-12v8h8V3h-8zm6 6h-4V5h4v4zm0 4h-2v2h2v-2zM11 13H9v4h2v-2h2v-2h-2v0zm6 0h-2v2h2v-2zm-2 4h-2v2h2v-2zm2-2h2v-2h-2v2zm0 6h2v-4h-2v4z"/></svg>
          </button>
          <button class="icon-btn" @click="openEdit(item)" aria-label="Editar" title="Editar">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83l3.75 3.75l1.83-1.83z"/></svg>
          </button>
          <button class="icon-btn icon-danger" @click="confirmDelete(item)" aria-label="Remover" title="Remover">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
          </button>
        </div>
      </button>
    </div>

    <EmptyState
      v-else
      :title="hasFilters ? 'Nenhum acampante encontrado' : 'Nenhum acampante cadastrado'"
      :description="hasFilters ? 'Tente outro filtro ou termo de busca.' : 'Clique em \'Novo\' para cadastrar o primeiro.'"
    />

    <AcampanteForm
      :visible="formVisible"
      :participant="formTarget"
      :submitting="submitting"
      @save="handleSave"
      @cancel="closeForm"
    />

    <AcampanteDetailsModal
      :visible="!!detailsTarget"
      :participant="detailsTarget"
      @close="detailsTarget = null"
      @edit="editFromDetails"
      @qr="qrFromDetails"
    />

    <div class="modal-overlay" v-if="qrTarget" @click.self="qrTarget = null">
      <div class="modal-card qr-modal">
        <h2 class="modal-title">QR Code</h2>
        <p class="qr-name">{{ qrTarget.name }}</p>
        <EquipeChip :equipe="qrTarget.equipe" />
        <div class="qr-display">
          <QrCodeDisplay :value="qrTarget.id" :size="280" />
        </div>
        <p class="qr-hint">Aponte o scanner para este código para fazer o check-in.</p>
        <div class="modal-actions">
          <button class="btn-secondary" @click="qrTarget = null">Fechar</button>
        </div>
      </div>
    </div>

    <div class="modal-overlay" v-if="deleteTarget" @click.self="deleteTarget = null">
      <div class="modal-card">
        <h2 class="modal-title">Remover acampante?</h2>
        <p class="confirm-text">
          Tem certeza que deseja remover <strong>{{ deleteTarget.name }}</strong>? Esta ação não pode ser desfeita.
        </p>
        <div class="modal-actions">
          <button class="btn-secondary" @click="deleteTarget = null">Cancelar</button>
          <button class="btn-danger" :disabled="deleting" @click="executeDelete">
            <span v-if="!deleting">Remover</span>
            <span v-else>Removendo...</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAcampantesStore } from '../stores/acampantes'
import { EQUIPES } from '../lib/equipes'
import AcampanteForm from '../components/AcampanteForm.vue'
import AcampanteDetailsModal from '../components/AcampanteDetailsModal.vue'
import EquipeChip from '../components/EquipeChip.vue'
import TransporteBadge from '../components/TransporteBadge.vue'
import QrCodeDisplay from '../components/QrCodeDisplay.vue'
import SkeletonLoader from '../components/ui/SkeletonLoader.vue'
import EmptyState from '../components/ui/EmptyState.vue'

function normalize(s) {
  return (s || '').toString().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
}

export default {
  name: 'AcampantesPage',
  components: { AcampanteForm, AcampanteDetailsModal, EquipeChip, TransporteBadge, QrCodeDisplay, SkeletonLoader, EmptyState },
  data() {
    return {
      searchQuery: '',
      equipeFilter: 'ALL',
      equipes: EQUIPES,
      formVisible: false,
      formTarget: null,
      submitting: false,
      qrTarget: null,
      deleteTarget: null,
      deleting: false,
      detailsTarget: null
    }
  },
  computed: {
    store() { return useAcampantesStore() },
    hasFilters() { return this.searchQuery.trim() !== '' || this.equipeFilter !== 'ALL' },
    semEquipeCount() {
      return this.store.acampantes.filter(a => !a.equipe).length
    },
    filtered() {
      let items = this.store.acampantes
      if (this.equipeFilter === 'NONE') {
        items = items.filter(a => !a.equipe)
      } else if (this.equipeFilter !== 'ALL') {
        items = items.filter(a => a.equipe === this.equipeFilter)
      }
      if (this.searchQuery.trim()) {
        const q = normalize(this.searchQuery)
        items = items.filter(a => normalize(a.name).includes(q) || normalize(a.contato).includes(q))
      }
      return items
    }
  },
  methods: {
    openNew() {
      this.formTarget = null
      this.formVisible = true
    },
    openEdit(item) {
      this.formTarget = item
      this.formVisible = true
    },
    openDetails(item) {
      this.detailsTarget = item
    },
    editFromDetails() {
      const target = this.detailsTarget
      this.detailsTarget = null
      if (target) this.openEdit(target)
    },
    qrFromDetails() {
      const target = this.detailsTarget
      this.detailsTarget = null
      if (target) this.openQr(target)
    },
    closeForm() {
      this.formVisible = false
      this.formTarget = null
    },
    async handleSave({ data }) {
      // Sucesso é notificado via Pusher (new-user / update-user) no App.vue
      // pra não duplicar toast quando a ação parte deste cliente.
      this.submitting = true
      try {
        if (this.formTarget) {
          await this.store.update(this.formTarget.id, data)
        } else {
          await this.store.create(data)
        }
        this.closeForm()
      } catch (err) {
        const msg = err.response?.data?.message || 'Erro ao salvar'
        this.$toast.open({ message: msg, type: 'error', position: 'top-right', duration: 4000 })
      } finally {
        this.submitting = false
      }
    },
    openQr(item) {
      this.qrTarget = item
    },
    confirmDelete(item) {
      this.deleteTarget = item
    },
    async executeDelete() {
      if (!this.deleteTarget) return
      this.deleting = true
      try {
        await this.store.remove(this.deleteTarget.id)
        // Sucesso notificado via Pusher (remove-user) no App.vue.
        this.deleteTarget = null
      } catch (err) {
        const msg = err.response?.data?.message || 'Erro ao remover'
        this.$toast.open({ message: msg, type: 'error', position: 'top-right', duration: 4000 })
      } finally {
        this.deleting = false
      }
    }
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--spacing-base);
  gap: var(--spacing-md);
}
.page-header .page-title { margin-bottom: 0; }

.filters {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-base);
}
.chip-row { display: flex; flex-wrap: wrap; gap: var(--spacing-sm); }
.filter-chip {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: 6px 14px;
  background: var(--color-bg-surface);
  color: var(--color-text-secondary);
  border: 1px solid var(--color-bg-separator);
  border-radius: 16px;
  font-size: var(--text-xs);
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-fast);
}
.filter-chip:hover { border-color: var(--color-accent); color: var(--color-accent); }
.filter-chip.active { background: var(--color-accent); border-color: var(--color-accent); color: #fff; }
.filter-chip-sem-equipe { border-style: dashed; color: var(--color-text-muted); }
.filter-chip-sem-equipe.active { background: var(--color-text-secondary); border-color: var(--color-text-secondary); color: #fff; }
.chip-count {
  background: rgba(0, 0, 0, 0.12);
  color: inherit;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
}

.search-box { position: relative; max-width: 420px; }
.search-input { padding-left: 38px; padding-right: 38px; }
.search-icon {
  position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
  color: var(--color-text-muted); pointer-events: none;
}
.clear-btn {
  position: absolute; right: 8px; top: 50%; transform: translateY(-50%);
  background: none; border: none; cursor: pointer; color: var(--color-text-muted);
  padding: 4px; display: inline-flex;
}
.clear-btn:hover { color: var(--color-danger); }

.acampante-list { display: flex; flex-direction: column; gap: var(--spacing-md); }
.acampante-item {
  display: flex; align-items: center; justify-content: space-between;
  gap: var(--spacing-base); padding: var(--spacing-base);
  transition: var(--transition-fast);
  width: 100%;
  font-family: var(--font-primary);
  font-size: inherit;
  color: inherit;
  text-align: left;
  border: none;
  cursor: pointer;
}
.acampante-item:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-hover);
}
.acampante-item:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}
.item-main { display: flex; flex-direction: column; gap: var(--spacing-xs); min-width: 0; flex: 1; }
.item-name-row { display: flex; align-items: center; gap: var(--spacing-sm); flex-wrap: wrap; }
.item-name { font-size: var(--text-md); font-weight: 600; color: var(--color-text-primary); }
.item-meta {
  display: flex; align-items: center; gap: var(--spacing-md); flex-wrap: wrap;
  font-size: var(--text-sm); color: var(--color-text-muted);
}
.item-status {
  display: inline-flex; align-items: center;
  font-size: var(--text-xs); font-weight: 700;
  padding: 2px 8px; border-radius: 10px;
}
.status-confirmed { background: rgba(46, 204, 113, 0.15); color: var(--color-success); }
.status-pending { background: rgba(243, 156, 18, 0.15); color: var(--color-warning); }

.item-actions { display: flex; gap: var(--spacing-xs); flex-shrink: 0; }
.icon-btn {
  width: 36px; height: 36px;
  display: inline-flex; align-items: center; justify-content: center;
  background: var(--color-bg-hover);
  border: 1px solid var(--color-bg-separator);
  border-radius: var(--radius-md);
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: var(--transition-fast);
}
.icon-btn:hover { background: var(--color-accent); color: #fff; border-color: var(--color-accent); }
.icon-btn.icon-danger:hover { background: var(--color-danger); border-color: var(--color-danger); }

.qr-modal { text-align: center; max-width: 380px; }
.qr-name { font-size: var(--text-lg); font-weight: 600; margin: var(--spacing-sm) 0 var(--spacing-md); color: var(--color-text-primary); }
.qr-display { display: flex; justify-content: center; margin: var(--spacing-base) 0; }
.qr-hint { font-size: var(--text-xs); color: var(--color-text-muted); margin-top: var(--spacing-sm); }

.confirm-text { font-size: var(--text-sm); color: var(--color-text-secondary); margin-bottom: var(--spacing-base); }

@media (max-width: 600px) {
  .acampante-item { flex-direction: column; align-items: stretch; }
  .item-actions { justify-content: flex-end; }
}
</style>
